import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { useDispatch } from "react-redux";
import MessageKeywords from "./MessageKeywords";
import {
  createMessageSegment,
  updateMessageSegment,
} from "../../redux/actions/messageSegmentSettings";
// import { updateAutomationSettings } from '../../../redux/actions/automationSettings';
// import UTCtime from './UTCtime';
// import TextEditor from './TextEditor';

const initialValues = {
  title: "",
  blocks: [],
};

const validateForm = (values) => {
  if (!values.title.trim()) {
    return {
      pass: false,
      errorMsg: "Please enter a title",
    };
  } else if (!values.blocks || values.blocks.length < 1) {
    return {
      pass: false,
      errorMsg: "Please add atleast one block",
    };
  } else {
    return {
      pass: true,
    };
  }
};

const MessageSegmentForm = ({ selectedMessageSegment, setOpenForm }) => {
  const [messageSegmentData, setMessageSegmentData] = useState(initialValues);
  const [messageText, setMessageText] = useState("");

  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    let validationRes = validateForm(messageSegmentData);
    if (validationRes.pass) {
      if (selectedMessageSegment?._id) {
        dispatch(
          updateMessageSegment(messageSegmentData, selectedMessageSegment?._id)
        );
      } else {
        dispatch(createMessageSegment(messageSegmentData));
      }
      setMessageSegmentData(initialValues);
      setOpenForm(false);
      return true;
    } else {
      toast.error(validationRes.errorMsg);
      return false;
    }
  };

  const handleRemoveMessageBlock = (index) => {
    const result = messageSegmentData?.blocks.filter((_, i) => i !== index);
    setMessageSegmentData({
      ...messageSegmentData,
      blocks: result,
    });
  };

  useEffect(() => {
    // console.log("selectedMessageSegment", selectedMessageSegment)
    if (selectedMessageSegment?._id) {
      setMessageSegmentData(selectedMessageSegment);
    }
  }, [selectedMessageSegment]);

  return (
    <div className="">
      <div className="modalDivWraper customizedModal activated">
        <div className="modalHeaderWraper">
          <h4 className="modalHeading">Create Message Segment</h4>
        </div>
        <div className="innerModalWraper messageFormWraper">
          <div className="fieldWrapers modalFields">
            {/* <h4 className="modalHeading">Create Message Segment</h4> */}
            <div className="input-group">
              <p className="message-segment-label">Enter Title</p>
              <div className="">
                <input
                  type="text"
                  className="message-segment-input"
                  placeholder="Enter your message segment title"
                  style={{ marginBottom: "0px" }}
                  onChange={(e) =>
                    setMessageSegmentData({
                      ...messageSegmentData,
                      title: e.target.value,
                    })
                  }
                  value={messageSegmentData.title}
                />
              </div>
            </div>

            <div className="input-group blockWraper">
              <p className="message-segment-label blockSection">
                Create Message Block(s)
              </p>
              <p
                className="smallSubInfo message-segment-description"
                style={{ textAlign: "left" }}
              >
                Click on the “keyword” to insert into your message
              </p>
              <p
              style={{
                fontSize: "12px",
                color: "rgba(155, 174, 188, 1)",
                marginTop: "8px",
                marginBottom: "15px",
                textAlign: "left",
                lineHeight: 1.75
              }}
            >
            *Note: To use SPINTAX in your message please follow this structure.
            <br />
            {`{Hello|Hi}, hope you're doing {good|fine|awesome}`}
            </p>

              <div className="message-segment-textarea-wrapper">
                <textarea
                  className="message-segment-input settingsForms"
                  rows={5}
                  id="default_message_text"
                  name="default_message_text"
                  placeholder="Enter your message"
                  value={messageText}
                  onChange={(e) => setMessageText(e.target.value)}
                />
                {messageText.trim() && (
                  <button
                    className="message-segment-add-button settingsAdd"
                    onClick={() => {
                      setMessageSegmentData({
                        ...messageSegmentData,
                        blocks: [...messageSegmentData.blocks, messageText],
                      });
                      setMessageText("");
                    }}
                  >
                    Add
                  </button>
                )}
              </div>
            </div>
            <MessageKeywords
            setMessage={(val)=> setMessageText(val)}
              // addKeyword={(val) =>
              //   setMessageText(`${messageText.trim()} ${val}`)
              // }
            />
            <div className="blocks-wrapper messageSettingsWraper">
              {messageSegmentData?.blocks?.length > 0 ? (
                messageSegmentData?.blocks?.map((item, i) => (
                  <div key={i} className="message-block-item">
                    <p>{item}</p>
                    <button onClick={() => handleRemoveMessageBlock(i)}>
                      X
                    </button>
                  </div>
                ))
              ) : (
                <p className="noBlockText">No Message Blocks Created Yet.</p>
              )}
            </div>
            <div className="buttonWraper customizeWraper messageSettingsBtnModalWraper">
              <button
                className="cancelBtn creates"
                onClick={() => setOpenForm(false)}
              >
                Cancel
              </button>
              <button className="confirmBtn" onClick={handleSubmit}>
                Save Message Segment
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageSegmentForm;
